import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import useRouteLeaveGuard from 'Hooks/useRouteLeaveGuard'
import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  ModalConfirm
} from 'mailup-web-components'

const ModalConfirmLeave = ({ isDirty, title, message }) => {
  const intl = useIntl()
  const [prompt, allow, deny] = useRouteLeaveGuard(!isDirty)

  const handleConfirm = () => {
    allow()
  }

  return (
    <ModalConfirm
      showClose
      show={prompt}
      closeOnOverlayClick
      size={MODAL_SIZE_SM}
      variant='delete'
      title={intl.formatMessage({
        id: title
      })}
      message={intl.formatMessage({
        id: message
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MessageOverview.Exit' })}
      onClickCancel={deny}
      onClickConfirm={handleConfirm}
      data-mu-test='modal-confirm-leave'
    />
  )
}

ModalConfirmLeave.defaultProps = {
  isDirty: false,
  title: 'Load.ModaleExitConfirm.Title',
  message: 'Load.ModaleExitConfirm.Description'
}

ModalConfirmLeave.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string
}

export default ModalConfirmLeave
